import { MetricConfig } from './tvd-types';

/**
 * Builds the shared Productivity / Energy / Water metrics config used by the TVD sidenavbar.
 * Region-specific config files differ only in whether the Productivity subheader is hidden.
 */
export function buildGenericMetricsConfig(hideSubHeader = false): MetricConfig[] {
  return [
    {
      metricName: 'Operational Performance',
      metricSubHeader: 'Productivity',
      hideSubHeader,
      metrics: [
        {
          id: 'productivity',
          title: 'Productivity',
          isHidden: false,
          isIncludePayload: true
        }
      ]
    },
    {
      metricName: 'Environmental Impact',
      metricSubHeader: '',
      metrics: [
        {
          id: 'energy',
          title: 'Energy',
          isHidden: false,
          isIncludePayload: false
        },
        {
          id: 'water',
          title: 'Water',
          isHidden: false,
          isIncludePayload: false
        }
      ]
    }
  ];
}

// Singleton configs — some consumers (e.g. TvdService) mutate these arrays in place,
// so each region/division must resolve to the same shared instance, not a fresh call per import.
export const EuTvdNavbarMetricsConfig = buildGenericMetricsConfig();
export const FrsTvdNavbarMetricsConfig = buildGenericMetricsConfig(true);
export const QsrTvdNavbarMetricsConfig = buildGenericMetricsConfig(true);
// Shared metrics config for regions that support country-scoped cost assumptions: AP, LA, IMEA
export const APLAIMEATvdNavbarMetricsConfig = buildGenericMetricsConfig();
